
import React from 'react';
import BaseComponent from  './Base';
import LegalPersonModalComponent from './LegalPerson';
import Select from 'react-select';
import SelectAsync from 'react-select/async';
import { Link } from 'react-router-dom';

//تنظیمات مروبوط به آژاکس سلکت باکس شهر
const loadLegalPersonsObjectsOptions = (inputValue, callback) => {
  setTimeout(() => {
    fetch("/api/organ/ajax/legalobjects/",{
      method: "post",
      body: JSON.stringify({"term":inputValue}),
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(response => response.json())
    .then(records =>{
      let items = [];
      records.map(_record=>items.push({value:_record.object_id,label:_record.title}));
      callback(items);
    })
    
  }, 50);
};
class AccountsAccess extends BaseComponent {
    constructor(props) {
      let config = {
        subModuleName : props.subModuleName,
        filterParams: [
          {value:'',name:"p",type:"string",default:''},
          {value:'',name:"s",type:"number",default:''},
        ]
      };

      super(props, config);
      this.state.action = (props.action === undefined || props.action === null ? "list" : props.action);
      this.state.subModuleName = props.subModuleName;
    }
    componentWillReceiveProps(props){
      this.setSearchValues("p","");
      this.setSearchValues("s","");
      this.state.data = null;
      this.state.subModuleName = props.subModuleName;
      this.state.list_url = '/api/organ/' + props.subModuleName + '/';
      this.state.action = (props.action === undefined || props.action === null ? "list" : props.action);
      this.state.filter = (props.filter !== undefined ? props.filter : "");
      this.setFilterParams();
      this.refresh();
    }
    getAccessTitle(_t){
      var s = _t.CivilicaAccessType === 0 ? "دسترسی اعتباری به مقالات داخلی" : "دسترسی سالانه به مقالات داخلی";
      if (_t.isi_access_type !== '' && _t.isi_access_type !== null)
      {
        if (s !== '') s += " و ";
        s += "دسترسی اعتباری به مقالات بین اللملی";
      }
      return s;
    }
    renderListView(){
      return (
        <div>
          <form onSubmit={e=>this.refresh(e)} className="row topSearchBar">
            <div className="col-sm-1" style={{"display":"none"}}>
              <Link className="btn bg-olive" to={"/" + this.state.subModuleName + "/new/"}>
                <i className="fa fa-plus"></i>
                <span> جدید</span>
              </Link>
            </div>
            <div className="col-sm-10">
              <input type="text" placeholder="جستجو" defaultValue="" className="form-control text-center" onChange={e => this.setSearchValues('p',e.target.value)} />
            </div>
            <div className="col-sm-2 recordCount">
              <button type="submit" className="hand">
                <i className="fa fa-search"></i>
              </button> | 
              <span> {this.money(this.state.data.record_count)} مورد</span>
            </div>
          </form>
          {this.state.data.record_count > 0 ?
            <div className="row">
              {this.state.data.records.map(_t=>
                <div className="col-md-12 col-sm-12 col-xs-12 topSearchBar" style={{"padding":"5px 26px"}}>
                  <span>
                    <Link to={"/accounts/mobiles/edit/" + _t.id}>{_t.value}</Link>
                  </span>
                  {_t.count !== 0 && _t.count !== null ?
                    <span className="label label-warning pull-left mr-r-5">دریافت {_t.count} مقاله در هر {_t.hour} ساعت</span>
                  :null}
                  <span className="label label-success pull-left mr-r-5">{this.getAccessTitle(_t)}</span>
                </div>
              )}
            </div>
          :
            <h4 className="alert alert-danger text-center">نتیجه ای برای نمایش یافت نشد</h4>
          }
          {this.createPaging()}
          {this.renderSettingForm()}
          {this.state.id_to_edit != null?          
            <LegalPersonModalComponent subModuleName={this.state.subModuleName} Id={this.state.id_to_edit} ParentComponent={this} />
          :null}
        </div>
      );
    }
    render() {
      if (this.state.data === null || this.state.data === undefined)
        return this.showLoading();
      if (this.state.data.status === 500 || this.state.data.status === 0)
        return this.render500()
      if (this.state.data.status === 404)
        return this.render404()
      if (this.state.data.status === 2)
        return this.renderNoAccess();
      if (this.state.data.status === 4)
        return this.renderNoLogin();
      return this.renderListView()
    }
  }
  export default AccountsAccess;